import { takeLatest, call, put } from 'redux-saga/effects'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/courses.action'
import individualCourses from '../../../api/courses/Individual'

async function handleIndividualDownloadCourse({
  courseId,
  filters,
  withVersions,
}) {
  return individualCourses(courseId, {
    filters,
    withVersions,
  })
}

function* coursesDownloadEffectSaga({
  payload,
}: fromActions.CoursesIndividualDownloadAction) {
  try {
    const { courseId, filters, withVersions } = payload

    const { data } = yield call(handleIndividualDownloadCourse, {
      courseId,
      filters,
      withVersions,
    })
    yield put(fromActions.Actions.coursesIndividualDownloadSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* coursesIndividualDownloadWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_INDIVIDUAL_DOWNLOAD,
    coursesDownloadEffectSaga
  )
}
